module.exports = __webpack_public_path__ + "img/ecology.c3ce2f24.jpg";